@if (mainFilename$ | async; as mainFilename) {
  <custom-checkout
    *axLazyElement="'checkout/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></custom-checkout>
}
